import { fetchConfig } from '../../utils/configUtils';
import { CONSTANTS, configKey } from '../../utils/constant';
import { generateUuid } from '../../utils/generateUuid';

export const getBrand = (): string => {
  const brand = (window as any).appConfig.BRAND_NAME;
  if (brand) return CONSTANTS.Brand[brand];

  return CONSTANTS.Brand.lloyds;
};

export const getHeaders = (
  apimKeyType: string,
): Record<string, string | number | boolean> => {
  const accessToken: string = sessionStorage.getItem('ACCESS_TOKEN') ?? '';
  const headerList = {
    'x-lbg-txn-correlation-id': generateUuid(),
    'x-lbg-brand': getBrand(),
    'Ocp-Apim-Subscription-Key': fetchConfig(configKey)[apimKeyType],
    'x-lbg-session-id': generateUuid(),
    'content-type': 'application/json',
    'x-lbg-source-channel': 'O4B',
    'x-lbg-access-token': accessToken,
    Accept: 'application/json',
  };
  Object.keys(headerList).forEach((headerKey) => {
    if (
      headerList[headerKey] === '' ||
      headerList[headerKey] === undefined ||
      headerList[headerKey] === null
    )
      delete headerList[headerKey];
  });
  return headerList;
};

export const setAccessToken = (accessTokenValue: string): void => {
  sessionStorage.setItem('ACCESS_TOKEN', accessTokenValue);
};

export const setRefreshToken = (refreshTokenValue: string): void => {
  sessionStorage.setItem('REFRESH_TOKEN', refreshTokenValue);
};
